module.exports = __webpack_public_path__ + "img/no-result-disliked.a84f05fa.png";